/* eslint-disable no-param-reassign */

import api from '@/services/api/team/team';
import { Storage, Cookie } from '@/utils/utils'
export default {
  state: {
    moduleTree: {},
    depart_id: '',
    defaultTreeArr: [],
    taskmeanData: {},
    selectItem: {}
  },

  mutations: {
    SET_MOELTREE: (state, data) => {
      state.moduleTree = data;
    },
    SET_DEPARTID: (state, data) => {
      state.defaultTreeArr = data
    },
    SET_AWITDER: (state, data) => {
      state.depart_id = data
    },
    SET_TASKMEANDATA: (state, data) => {
      state.taskmeanData = data
    },
    SET_SELECTITEM: (state, data) => {
      state.selectItem = data
    }
  },

  getters: {},

  actions: {
    getuserlist({
      commit,
      state,
      dispatch
    }, params) {
      return new Promise((resolve, reject) => {
        api.getuserlist().then((res) => {
          let depart_id = Storage.get('wfUserInfo').depart_id
          commit('SET_MOELTREE', res)
          let tree = (id, key) => {
            for (let i = 0; i < key.length; i++) {
              if (key[i].id == id) {
                return key[i]
              } else if (key[i].children) {
                let obj = tree(id, key[i].children)
                if (obj) {
                  return obj
                }
              }
            }
          }
          let listbox = [tree(depart_id, res.departmentgroup)]
          let arrId = []
          let list = (data) => {
            for (let i = 0; i < data.length; i++) {
              arrId.push(data[i].id)
              if (data[i].children) {
                list(data[i].children)
              }
            }
          }
          list(listbox)
          commit('SET_DEPARTID', arrId)
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    getTableData({
      commit,
      state,
      dispatch
    }, id) {
      let data = JSON.parse(JSON.stringify(state.moduleTree.departmentgroup))

    }
  },
};
